/** SA-1029 (spec §D21): the live notices a task page shows as a banner —
 * set on `record_update_received`, cleared on `record_update_settled`.
 * Reset on an identity change (identityScope.ts): a notice belongs to the
 * identity that received it. The record page never reads it (its chip is
 * the refetched order). */
import { create } from 'zustand'

export interface RecordUpdateNotice { updateId: string; orderNumber: string; kind: 'update' | 'response' }

interface State {
  notices: Record<string, RecordUpdateNotice>
  set: (orderId: string, notice: RecordUpdateNotice) => void
  clear: (orderId: string) => void
}

export const useRecordUpdateNoticeStore = create<State>((set) => ({
  notices: {},
  set: (orderId, notice) => set((s) => ({ notices: { ...s.notices, [orderId]: notice } })),
  clear: (orderId) => set((s) => {
    const { [orderId]: _gone, ...rest } = s.notices
    return { notices: rest }
  }),
}))
